import { describeGranolaHealth, pickEnum } from '@eo/shared';

import { SETTINGS_TAB_VALUES } from './constants';
import type { IntegrationKey, IntegrationStatus, SettingsState, SettingsTab } from './types';

export function statusOf(data: SettingsState, key: IntegrationKey): IntegrationStatus {
  if (key === 'google') {
    return {
      connected: data.google.connected,
      detail: data.google.email,
      verifiedAt: null,
      account: null,
    };
  }
  if (key === 'slack') {
    return {
      connected: data.slack.connected,
      detail: data.slack.slackUserId,
      verifiedAt: null,
      account: null,
    };
  }
  if (key === 'granola') {
    return {
      connected: data.granola.connected,
      detail: data.granola.preview,
      verifiedAt: data.granola.verifiedAt,
      account: data.granola.account,
      ...describeGranolaHealth(data.granola),
    };
  }
  return {
    connected: data.clickup.connected,
    detail: data.clickup.preview,
    verifiedAt: data.clickup.verifiedAt,
    account: data.clickup.account,
  };
}

export function checkedLabel(iso: string | null): string | null {
  if (!iso) return null;
  const date = new Date(iso);
  return isNaN(date.getTime())
    ? null
    : `Checked ${new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      }).format(date)}`;
}

export function parseTab(value: string | null): SettingsTab {
  return pickEnum(SETTINGS_TAB_VALUES, value, 'account');
}
